import React, { useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useWebMode } from '../context/WebModeContext';

const Header = () => {
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const { isWeb3Mode, toggleWebMode } = useWebMode();

  const burgerMenuRef = useRef(null);
  const overlayRef = useRef(null);

  const handleBurgerMenuClick = () => {
    burgerMenuRef.current.classList.toggle("close");
    overlayRef.current.classList.toggle("overlay");
  };

  const handleModeToggle = () => {
    toggleWebMode();
    // If we're on the homepage, we don't need to navigate since the component will update automatically
    // Only navigate if we're on the work page
    const path = currentLocation.pathname;
    if (path === '/work') {
      navigate(isWeb3Mode ? '/work' : '/WorkWebThree');
    } else if (path === '/WorkWebThree') {
      navigate(isWeb3Mode ? '/work' : '/WorkWebThree');
    }
  };

  return (
    <div className="header bg-secondary_background text-secondary_txt flex justify-between pr-[8vw] md:pr-[5vw] py-[1.2em]  md:py-0">

      <div id="burger-menu" ref={burgerMenuRef} className="md:hidden inline-block ml-[8vw] py-[1.2em]" onClick={handleBurgerMenuClick}>
  <span></span>
</div>

      <div id="menu" className='py-[1em]' ref={overlayRef}>
  <ul>
    <li>{currentLocation.pathname !== "/" && <Link to="/">Home</Link>}</li>
    <li>{currentLocation.pathname !== "/About" && <Link to="/About">About</Link>}</li>
    <li>{currentLocation.pathname !== "/Work" && <Link to="/Work">Work</Link>}</li>
    <li>{currentLocation.pathname !== "/Blog" && <Link to="/Blog">Blog</Link>}</li>
    <li>{currentLocation.pathname !== "/Contact" && <Link to="/Contact">Contact</Link>}</li>
    <li>
      <a className='' href={isWeb3Mode ? '/Resume Web3.pdf' : '/Resume.pdf'} download=''>Resume</a>
    </li>
  </ul>
</div>
      <ul className="headerlist hidden md:flex text-[24px] pl-[2vw] border-t-[0.3em] border-secondary_background">
      <li className={`inline  flexCol px-[0.6em] border-box`} data-aos="fade-right" data-aos-delay="100"  data-aos-once="true">
  {currentLocation.pathname !== '/' && (
    <Link to="/"><img src='./favicon.ico' className='h-[2.5em]'></img></Link>
  )}
</li>
      <li className={`inline pb-[1.2em] pt-[0.9em] px-[0.6em] border-box ${
        currentLocation.pathname === '/About'
          ? isWeb3Mode
            ? 'active2'
            : 'active'
          : ''
      }`} data-aos="fade-right" data-aos-delay="200"  data-aos-once="true">
          <Link to="/About">About</Link>
        </li>
        <li className={`inline pb-[1.2em] pt-[0.9em] px-[0.6em] border-box ${
          currentLocation.pathname === '/Work'
            ? isWeb3Mode
              ? 'active2'
              : 'active'
            : ''
        }`} data-aos="fade-right" data-aos-delay="300">
          <Link to="/Work">Work</Link>
        </li>
        <li className={`inline pb-[1.2em] pt-[0.9em] px-[0.6em] border-box ${
          currentLocation.pathname === '/Contact'
            ? isWeb3Mode
              ? 'active2'
              : 'active'
            : ''
        }`} data-aos="fade-right" data-aos-delay="400"  >
          <Link to="/Contact">Contact</Link>
        </li>
        <li className={`inline pb-[1.2em] pt-[0.9em] px-[0.6em] border-box`} data-aos="fade-right" data-aos-delay="500"  >
          <a className='' href={isWeb3Mode ? '/Resume Web3.pdf' : '/Resume.pdf'} download=''>Resume</a>
        </li>

      </ul>


        <div className='flexCol text-[29px]'>
            <div className='flex gap-[1.2em] items-center'>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-white">Web 2</span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={isWeb3Mode}
                  onChange={toggleWebMode}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
              <span className="text-sm font-medium text-white">Web 3</span>
            </div>
            <a href="https://www.x.com/kumarlaksh06" target='_blank' data-aos="fade-left" data-aos-delay="200">
            <svg  className=' h-[1em]' viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.1961 28.56L17.7786 11.9147L17.7981 11.9303L28.0926 0H24.6525L16.2662 9.7104L9.60654 0H0.584181L11.2436 15.5405L11.2423 15.5392L0 28.56H3.44018L12.7637 17.7565L20.1737 28.56H29.1961ZM8.24345 2.59636L24.263 25.9636H21.5368L5.50429 2.59636H8.24345Z" fill="white"/>
</svg></a>

<a href="https://www.linkedin.com/in/kumar-laksh" target='_blank' data-aos="fade-left" data-aos-delay="100"> <svg className=' h-[1em]' viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.12 0.720001C2.25033 0.720001 0.720001 2.25033 0.720001 4.12V25.88C0.720001 27.7497 2.25033 29.28 4.12 29.28H25.88C27.7497 29.28 29.28 27.7497 29.28 25.88V4.12C29.28 2.25033 27.7497 0.720001 25.88 0.720001H4.12ZM4.12 2.08H25.88C27.0146 2.08 27.92 2.98543 27.92 4.12V25.88C27.92 27.0146 27.0146 27.92 25.88 27.92H4.12C2.98543 27.92 2.08 27.0146 2.08 25.88V4.12C2.08 2.98543 2.98543 2.08 4.12 2.08ZM7.52 5.48797C6.77525 5.48797 6.10507 5.71058 5.60883 6.12813C5.11258 6.54568 4.80797 7.16947 4.80797 7.83743C4.80797 9.10711 5.90928 10.0969 7.31016 10.1948C7.31104 10.1953 7.31193 10.1957 7.31282 10.1962C7.37957 10.2189 7.44949 10.231 7.52001 10.232C9.06565 10.232 10.232 9.14934 10.232 7.83743C10.2319 7.82546 10.2315 7.8135 10.2307 7.80156C10.1615 6.50941 9.0095 5.48797 7.52 5.48797ZM7.52 6.83203C8.46672 6.83203 8.84054 7.25483 8.88133 7.85469C8.87306 8.43694 8.51286 8.88797 7.52 8.88797C6.57792 8.88797 6.15203 8.40552 6.15203 7.83743C6.15203 7.55338 6.25568 7.33933 6.47344 7.1561C6.6912 6.97287 7.04075 6.83203 7.52 6.83203ZM5.48 10.92C5.10446 10.92 4.80004 11.2245 4.8 11.6V24.52C4.80004 24.8955 5.10446 25.2 5.48 25.2H9.56C9.93554 25.2 10.24 24.8955 10.24 24.52V20.5316V11.6C10.24 11.2245 9.93554 10.92 9.56 10.92H5.48ZM11.6 10.92C11.2245 10.92 10.92 11.2245 10.92 11.6V24.52C10.92 24.8955 11.2245 25.2 11.6 25.2H15.68C16.0555 25.2 16.36 24.8955 16.36 24.52V17.72C16.36 17.1558 16.5139 16.5946 16.785 16.2272C17.0561 15.8598 17.398 15.6392 18.048 15.6508C18.7183 15.6623 19.0732 15.8919 19.3416 16.2524C19.6101 16.6129 19.76 17.1533 19.76 17.72V24.52C19.76 24.8955 20.0645 25.2 20.44 25.2H24.52C24.8955 25.2 25.2 24.8955 25.2 24.52V17.218C25.2 15.2041 24.6035 13.6089 23.581 12.5297C22.5585 11.4504 21.1364 10.92 19.6325 10.92C18.2031 10.92 17.1154 11.3993 16.36 11.8882V11.6C16.36 11.2245 16.0555 10.92 15.68 10.92H11.6ZM6.16 12.28H8.88V20.5316V23.84H6.16V12.28ZM12.28 12.28H15V13.3412C15.0001 13.6336 15.1871 13.8932 15.4644 13.9859C15.7417 14.0787 16.0472 13.9838 16.2232 13.7502C16.2232 13.7502 17.291 12.28 19.6325 12.28C20.8248 12.28 21.8472 12.6762 22.5942 13.4647C23.3413 14.2532 23.84 15.468 23.84 17.218V23.84H21.12V17.72C21.12 16.9267 20.9299 16.1064 20.4333 15.4396C19.9368 14.7728 19.1016 14.3085 18.0719 14.2908C17.037 14.2724 16.1883 14.7464 15.6906 15.421C15.1929 16.0957 15 16.9242 15 17.72V23.84H12.28L12.28 12.28Z" fill="white"/>
</svg></a>

</div>
        </div>
    </div>
  );
};

export default Header;